import { Space, Tag, Tooltip } from 'antd';
import { issuesConfig } from './constants/issuesConfig';

/** Muestra una etiqueta en la parte superior del contenedor padre que indica si hay errores, alertas o inconsistencias. */
export const IssuesTag = ({ errors, alerts, inconsistencies }) => {
  const issues = [
    { type: 'error', count: errors?.length },
    { type: 'alert', count: alerts?.length },
    { type: 'inconsistency', count: inconsistencies?.length },
  ].filter(({ count }) => count > 0);

  if (!issues.length) return null;

  const hasMultipleIssueTypes = issues.length > 1;

  return (
    <Space
      style={{
        position: 'absolute',
        top: -8,
        left: '50%',
        transform: 'translateX(-50%)',
      }}
    >
      {issues.map(({ type, count }) => {
        const { icon, color, label } = issuesConfig[type];
        const finalLabel = count > 1 ? label.plural : label.singular;

        return (
          <Tooltip key={type} title={hasMultipleIssueTypes ? finalLabel : null}>
            <Tag
              color={color}
              style={{ margin: 0 }}
            >
              <Space>
                {icon}
                {!hasMultipleIssueTypes && finalLabel}
              </Space>
            </Tag>
          </Tooltip>
        )
      })}
    </Space>
  );
};